import useGlobals from './useGlobals.js';
import { siteThemes } from '../utils/theming.js';

function useIsGlobetrotter() {
  var _useGlobals = useGlobals(),
    legacyMode = _useGlobals.legacyMode,
    theme = _useGlobals.theme;
  return siteThemes.GLOBETROTTER === theme.site && !legacyMode;
}

export { useIsGlobetrotter as default };
//# sourceMappingURL=useIsGlobetrotter.js.map
